// SPDX-License-Identifier: AGPL-3.0-or-later

const CHANNEL_MESSAGES_SCROLLER = '[data-flx="channel.messages.scroller"][data-fluxer-scroll-container="true"]';
const CHANNEL_MESSAGES_INNER = '[data-flx="channel.messages.scroller-inner"]';

export type FocusedReactionFlushAction = 'inChannelSound' | 'obscuredSound' | 'popup';

export interface RectEdge {
	top: number;
	bottom: number;
}

function cssEscape(value: string): string {
	if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
		return CSS.escape(value);
	}
	return value.replace(/["\\]/g, '\\$&');
}

export function messageRowIntersectsScroller(message: RectEdge | null, scroller: RectEdge): boolean {
	if (message == null) {
		return false;
	}
	return message.bottom > scroller.top && message.top < scroller.bottom;
}

export function resolveFocusedReactionFlushAction(input: {
	hasModalOpen: boolean;
	isMessageRowVisible: boolean;
}): FocusedReactionFlushAction {
	if (input.hasModalOpen) {
		return 'obscuredSound';
	}
	if (input.isMessageRowVisible) {
		return 'inChannelSound';
	}
	return 'popup';
}

export function isChannelMessageRowVisible(channelId: string, messageId: string): boolean {
	if (typeof document === 'undefined') {
		return false;
	}
	const scroller = document.querySelector<HTMLElement>(CHANNEL_MESSAGES_SCROLLER);
	if (scroller == null) {
		return false;
	}
	const inner = scroller.querySelector(CHANNEL_MESSAGES_INNER) ?? scroller;
	const selector = `[role="article"][data-channel-id="${cssEscape(channelId)}"][data-message-id="${cssEscape(messageId)}"]`;
	const messageEl = inner.querySelector<HTMLElement>(selector);
	if (messageEl == null) {
		return false;
	}
	const messageRect = messageEl.getBoundingClientRect();
	const scrollerRect = scroller.getBoundingClientRect();
	return messageRowIntersectsScroller(
		{top: messageRect.top, bottom: messageRect.bottom},
		{top: scrollerRect.top, bottom: scrollerRect.bottom},
	);
}
